import { Exclude, Expose, Type } from 'class-transformer';
import moment, { Moment } from 'moment';

@Exclude()
export class TwitterAccountDTO {
  @Expose()
  @Type(() => String)
  id: string;

  @Expose()
  username: string;

  @Expose()
  pic: string;

  @Expose()
  verified: boolean;

  @Expose()
  name: string;

  @Expose()
  twitterId: string;

  @Expose()
  friends: number;

  @Expose()
  followers: number;
}
